module.exports = __webpack_public_path__ + "static/media/scroll4_phone1.3eb42aab.png";